/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerBasicFromJSON, CustomerBasicToJSON, } from './CustomerBasic';
/**
 * Check if a given object implements the MeteringPoint interface.
 */
export function instanceOfMeteringPoint(value) {
    if (!('meteringPointId' in value) || value['meteringPointId'] === undefined)
        return false;
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('erp' in value) || value['erp'] === undefined)
        return false;
    if (!('profile' in value) || value['profile'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('plan' in value) || value['plan'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    return true;
}
export function MeteringPointFromJSON(json) {
    return MeteringPointFromJSONTyped(json, false);
}
export function MeteringPointFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'meteringPointId': json['metering_point_id'],
        'customer': CustomerBasicFromJSON(json['customer']),
        'name': json['name'],
        'status': json['status'],
        'erp': json['erp'],
        'profile': json['profile'],
        'address': json['address'],
        'plan': json['plan'],
        'price': json['price'],
    };
}
export function MeteringPointToJSON(json) {
    return MeteringPointToJSONTyped(json, false);
}
export function MeteringPointToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'metering_point_id': value['meteringPointId'],
        'customer': CustomerBasicToJSON(value['customer']),
        'name': value['name'],
        'status': value['status'],
        'erp': value['erp'],
        'profile': value['profile'],
        'address': value['address'],
        'plan': value['plan'],
        'price': value['price'],
    };
}
